const TopicOne = () => {
  return (
    <div className="quality-section-market">
      <div className="quality-header-market">
        <h1>Trading tools</h1>
        
      </div>
    </div>
  );
};

export default TopicOne;
